import { render, staticRenderFns } from "./MaterialFilter.vue?vue&type=template&id=7dbb83de&"
import script from "./MaterialFilter.vue?vue&type=script&lang=js&"
export * from "./MaterialFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports